import {
  Circle,
  Club,
  Cross,
  Diamond,
  Heart,
  Hexagon,
  LucideIcon,
  Octagon,
  Pentagon,
  Spade,
  Sparkle,
  Square,
  Star,
  Triangle,
} from 'lucide-react';

export const shapes = [
  Circle,
  Triangle,
  Square,
  Diamond,
  Hexagon,
  Octagon,
  Pentagon,
  Sparkle,
  Star,
  Spade,
  Club,
  Heart,
  Cross,
];

export function getDeterministicShape(index: number): LucideIcon {
  return shapes[index % shapes.length];
}
